import { ReactComponent as CloseSvg } from '../../../../assets/icons/Close.svg';

import { createIconComponent } from './createIconComponent';

export const CloseIcon = createIconComponent(CloseSvg);
